var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewLocation = function SvgNewLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.2.0-Health-screening-/-Upcoming-/-View-more---check-in",
    transform: "translate(-1199.000000, -289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/09.Web/07.View-action/3-row/Right",
    transform: "translate(1183.000000, 263.237096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 25.762904)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99999997,2.99999996 C12.756875,2.99999996 15,5.14531247 15,7.78124999 C15,9.03718749 14.4278125,10.7065625 13.30125,12.743125 C12.395,14.37875 11.345625,15.8578125 10.80125,16.59375 C10.6143637,16.8487842 10.3171161,16.999477 10.0009375,16.999477 C9.68475888,16.999477 9.38751132,16.8487842 9.200625,16.59375 C8.65531249,15.8578125 7.60687499,14.37875 6.70062498,12.743125 C5.57218747,10.7059375 4.99999997,9.03656249 4.99999997,7.78124999 C4.99999997,5.14531247 7.24312498,2.99999996 9.99999997,2.99999996 Z M9.99999999,5.99999997 C8.89543049,5.99999997 7.99999999,6.89543048 7.99999999,7.99999997 C7.99999999,9.10456949 8.89543049,9.99999997 9.99999999,9.99999997 C11.1040697,9.9987944 11.9987944,9.10406973 12,7.99999997 C12,6.89543048 11.1045695,5.99999997 9.99999999,5.99999997 Z M9.99999999,6.99999998 C10.5522848,6.99999998 11,7.44771523 11,7.99999998 C11,8.55228474 10.5522848,8.99999998 9.99999999,8.99999998 C9.44771525,8.99999998 8.99999999,8.55228474 8.99999999,7.99999998 C8.99999999,7.44771523 9.44771525,6.99999998 9.99999999,6.99999998 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-location.2a775dd4.svg";
export { ForwardRef as ReactComponent };